import React from 'react'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import { Link } from 'gatsby'
import ArrowRight from 'icons/arrow_right.svg'

export const Element = styled((props) => <Link {...props} />)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${calculateResponsiveSize(6)};
  width: ${({ $width }) => $width ? calculateResponsiveSize($width) : 'fit-content'};
  height: ${calculateResponsiveSize(20)};
  text-decoration: none !important;
  font-size: ${calculateResponsiveSize(10)};
  color: var(--Terracotta);
  font-weight: 600;
  line-height: 1;
  letter-spacing: ${calculateResponsiveSize(1)};
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid var(--Terracotta);
  border-radius: 6px;
  background: white;
  transition: color 0.5s, border 0.5s, background 0.5s;
  position: relative;
  cursor: pointer;
  @media (any-hover: hover) {
    &:hover {
      color: white;
      border: 1px solid var(--Terracotta);
      background: var(--Terracotta);
      & span.text {
        transform: translateX(0);
      }
      & span.arrow {
        opacity: 1;
        background: white;
        transform: translateX(0);
      }
    }
  }
  &.white-bg-hover-bg-terracotta {
    color: var(--Terracotta);
    border: 1px solid white;
    background: white;
    @media (any-hover: hover) {
      &:hover {
        color: white;
        border: 1px solid var(--Terracotta);
        background: var(--Terracotta);
        & .arrow {
          background: white;
        }
      }
    }
  }
  &.white-outline-hover-bg-white {
    color: white;
    border: 1px solid white;
    background: transparent;
    @media (any-hover: hover) {
      &:hover {
        color: var(--Terracotta);
        border: 1px solid white;
        background: white;
        & .arrow {
          background: var(--Terracotta);
        }
      }
    }
  }
  &.terracotta {
    color: white;
    border: 1px solid var(--Terracotta);
    background: var(--Terracotta);
    @media (any-hover: hover) {
      &:hover {
        color: white;
        border: 1px solid var(--Terracotta);
        background: var(--Terracotta);
        & .arrow {
          background: white;
        }
      }
    }
  }
  &.back {
    & span.text {
      transform: translateX(${calculateResponsiveSize(-11)});
    }
    & .arrow {
      order: -1;
      transform: translateX(${calculateResponsiveSize(-11)}) rotate(180deg);
    }
    @media (any-hover: hover) {
      &:hover span.text {
        transform: translateX(0);
      }
      &:hover span.arrow {
        transform: translateX(0) rotate(180deg);
      }
    }
  }
  & span.text {
    text-box-trim: trim-both;
    text-box-edge: cap alphabetic;
    transform: translateX(${calculateResponsiveSize(11)});
    transition: opacity 0.5s, transform 0.5s;
  }
  & .arrow {
    width: ${calculateResponsiveSize(16)};
    height: ${calculateResponsiveSize(20)};
    background: white;
    mask-position: center 51%;
    mask-repeat: no-repeat;
    mask-size: ${calculateResponsiveSize(16)} ${calculateResponsiveSize(9)};
    mask-image: url(${ArrowRight});
    -webkit-mask-position: center 51%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: ${calculateResponsiveSize(16)} ${calculateResponsiveSize(9)};
    -webkit-mask-image: url(${ArrowRight});
    opacity: 0;
    transform: translateX(${calculateResponsiveSize(11)});
    transition: opacity 0.5s, transform 0.5s;
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(3)};
    width: ${({ $widthMobile }) => $widthMobile ? calculateMobileResponsiveSize($widthMobile) : 'fit-content'};
    height: ${calculateMobileResponsiveSize(16)};
    font-size: ${calculateMobileResponsiveSize(8)};
    letter-spacing: ${calculateMobileResponsiveSize(0.8)};
    border-radius: 4px;
    &.back {
      & span.text {
        transform: translateX(${calculateMobileResponsiveSize(-6)});
      }
      & .arrow {
        transform: translateX(${calculateMobileResponsiveSize(-6)}) rotate(180deg);
      }
    }
    & span.text {
      transform: translateX(${calculateMobileResponsiveSize(6)});
    }
    & .arrow {
      width: ${calculateMobileResponsiveSize(10)};
      height: ${calculateMobileResponsiveSize(16)};
      mask-size: ${calculateMobileResponsiveSize(10)} ${calculateMobileResponsiveSize(6)};
      -webkit-mask-size: ${calculateMobileResponsiveSize(10)} ${calculateMobileResponsiveSize(6)};
      transform: translateX(${calculateMobileResponsiveSize(6)});
    }
  }
`
